import i18n from './../i18n'

export const DATA_TRANSLATIONS = {
  osszesen: 'all',
  beteg: 'ill',
  kontakt: 'contact',
  megfigyelt: 'under observation',
  gyogyult: 'recovered',
  elhunyt: 'deceased',
  'megfigyeles_vege': 'end of observation',
  fertozott: 'infected',
  karanten: 'home quarantine',
  lezart: 'restricted area',
  tervezet: 'planned area',
  kitelepulesi: 'evacuation area',
  tartalek: 'supplies',
  ideiglenes: 'temporary station'
}

/**
 * Translation helper for v-select items
 * @param array
 * @returns {*}
 */
export const translateLabel = (array) => {
  return array.map(x => ({ ...x, label: i18n.t(DATA_TRANSLATIONS[x.value]), text: i18n.t(DATA_TRANSLATIONS[x.value]) }))
}
